export enum CHANGE_OF_STATE_DIRECTION {
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
}
